<mat-card>
  <mat-card-title translate="account/links/shortener/title"></mat-card-title>
  <mat-card-subtitle translate="account/links/shortener/description"></mat-card-subtitle>
  <mat-card-content>
    <app-select
      [control]="siteControl"
      [items]="sitesChoices"
      data-testid="filter-account"
      [localStorageKey]="localStorageKey"
      [optionTemplateName]="'site-icon'"
      appearance="outline"
      [labelKey]="'account'">
    </app-select>
    <div class="tabs-wrapper">
      <mat-tab-group mat-align-tabs="start">
        <mat-tab *ngFor="let subconfig of subconfigs">
          <ng-template matTabLabel>
            <span
              [attr.data-testid]="'links-settings-title-' + subconfig.id"
              [translate]="'account/links/' + subconfig.id"></span>
          </ng-template>
          <ng-template matTabContent>
            <div [attr.data-testid]="'links-settings-content-' + subconfig.id">
              <app-links-subconfig
                [data]="subconfig"
                (subConfigChanged)="shouldDisableSaveForLinks(false)"></app-links-subconfig>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <button
      type="submit"
      mat-raised-button
      [disabled]="linksSubmitDisabled"
      color="primary"
      data-testid="links-settings-save"
      (click)="saveLinksChanges()"
      translate="save"></button>
    <button mat-raised-button (click)="cancelLinksChanges()" translate="cancel"></button>
  </mat-card-actions>
</mat-card>

<mat-card>
  <mat-card-title translate="account/links/skeepers/title"></mat-card-title>
  <mat-card-subtitle [innerHtml]="'account/links/skeepers/description' | translate"></mat-card-subtitle>
  <mat-card-content>
    <form [formGroup]="form">
      <p>
        <mat-slide-toggle formControlName="allowed" color="primary">
          <span translate="account/links/skeepers/activate-encryption"></span>
        </mat-slide-toggle>
      </p>

      <p>
        <mat-form-field>
          <mat-label translate="account/links/skeepers/encrypt-key"></mat-label>
          <input matInput formControlName="encryption_key" type="text" />
        </mat-form-field>
      </p>

      <p>
        <mat-form-field>
          <mat-label translate="account/links/skeepers/auth-key"></mat-label>
          <input matInput formControlName="authentication_key" type="text" />
        </mat-form-field>
      </p>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <button
      type="submit"
      mat-raised-button
      [disabled]="form.pristine || form.invalid"
      data-testid="links-connector-save"
      color="primary"
      (click)="saveConnectorChanges()"
      translate="save"></button>
    <button mat-raised-button (click)="cancelConnectorChanges()" translate="cancel"></button>
  </mat-card-actions>
</mat-card>
